<template>
  <div>
    <v-autocomplete :value="entity" :items="filterEntities" :label="$i18n.t(label)" @change="changedTo"
      @click:clear="clear" :loading="loading" :clearable="clearable" :rules="rules" :search-input.sync="filter"
      ref="select" autocomplete="nope" :disabled="disabled" :no-filter="true" v-if="hide === false"
      :multiple="isMultiple">
      <template v-slot:selection="data">
        <div v-if="isMultiple">
          <div class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default">
            {{ data.item.name }}
          </div>
        </div>
        <div ripple dense class="height32" v-else>
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float: right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
      <template v-slot:append-item v-if="$ha(701)">
        <div class="actionBox">
          <v-btn small text color="info" @click="entityCreateDialog = true">
            <v-icon>mdi-plus</v-icon>
            {{ $i18n.t("Add New Entity") }}
          </v-btn>
        </div>
      </template>
    </v-autocomplete>
    <z-entity-create @select="selectEntity" :showDialog="entityCreateDialog" :forClient="corp"></z-entity-create>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";

import { Vue, Component, Watch } from "vue-property-decorator";
import CorpService from "@/store/common/module/CorpService";

@Component({
  name: "EntitySelect",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: null,
    },
    label: {
      default: "Entity",
    },
    clearable: {
      default: false,
    },
    autoSelect: {
      default: false,
    },
    hideLone: {
      default: false,
    },
    disabled: {
      default: false,
    },
    rules: {
      default: () => [],
    },
    item: {
      default: null,
    },
    multiple: {
      default: false,
    },
    showCorpNames: {
      default: false,
    }
  },
})
export default class EntitySelect extends (Vue, Themeable) {
  entity = null;
  entities = [];
  loading = true;
  filter = "";
  hide = false;
  entityCreateDialog = false;
  selectedValue = null;
  isMultiple = false;

  @Watch("value")
  onValueChange(newVal) {
    this.selectedValue = newVal;
    this.selectValue();
  }

  async selectEntity(newEntity) {
    this.entityCreateDialog = false;
    if (newEntity != null) {
      this.selectedValue = newEntity._id;
      await this.init(this.corp);
      // this.changedTo(newEntity);
    }
  }

  clear() {
    this.filter = "";
    this.entity = null;
    this.$emit("input", null);
    this.$emit("fullEntity", null, this.item);
  }

  get filterEntities() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.entities;
    const fs = this.entities.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (!this.isMultiple) {
      if (newVal) {
        this.entity = newVal;
      }
      if (newVal && newVal.name) {
        this.$emit("input", newVal._id);
        this.$emit("fullEntity", newVal, this.item);
      }
      if (!newVal) {
        this.$emit("input", null);
        this.$emit("fullEntity", null, this.item);
      }
    } else {
      const response = [];
      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i]._id);
      }
      this.entity = newVal;
      this.$emit("input", response);
      return;
    }

  }

  selectValue() {
    if (this.entities && this.entities.length == 1 && this.hideLone !== false) {
      this.hide = true;
    }
    if (this.selectedValue) {
      for (let i = 0; i < this.entities.length; i++) {
        if (this.entities[i]._id === this.selectedValue) {
          this.entity = this.entities[i];
          this.$emit("input", this.entity._id);
          this.$emit("fullEntity", this.entity, this.item);
          return;
        }
      }
    }
    if (this.autoSelect !== false) {
      if (this.entities.length == 1) {
        this.entity = this.entities[0];
        this.$emit("input", this.entity._id);
        this.$emit("fullEntity", this.entity, this.item);
        return;
      }
      for (let i = 0; i < this.entities.length; i++) {
        if (this.entities[i].isDefault == true) {
          this.entity = this.entities[i];
          this.$emit("input", this.entity._id);
          this.$emit("fullEntity", this.entity, this.item);
          return;
        }
      }
    }
  }

  async init(val) {
    this.isMultiple = this.multiple === "" || this.multiple === true;
    if (val != null && val !== "" && val != false) {
      this.filter = "";
      this.loading = true;
      await CorpService.populateBUs(val);
      this.entities = CorpService.bus[val];
      if (this.entities != null && this.entities.length > 0 && this.showCorpNames) {
        for (let i = 0; i < this.entities.length; i++) {
          if (this.entities[i] != null && this.entities[i].corpName != null) {
            this.entities[i].name = this.entities[i].name + " , " + this.entities[i].corpName;
          }
        }
      }
      this.loading = false;
      this.selectedValue = this.value;
      this.selectValue();
    } else {
      this.entities = [];
      this.loading = false;
      this.selectValue();
    }
  }

  async mounted() {
    await this.init(this.corp);
    this.loading = false;
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.entity != null
    ) {
      if (Array.isArray(this.entity) && this.entity.length > 0) {
        for (let i = 0; i < this.entity.length; i++) {
          if (val._id === this.entity[i]._id) {
            return true;
          }
        }
      } else {
        if (val._id === this.entity._id) {
          return true;
        }
      }
    }
    return false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}

.menuable__content__active,
.v-menu__content {
  background: white;
}

.v-select__selections {
  height: 32px;
}

.height32 {
  height: 32px;
}

.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}

.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
